module.exports = {"id":"198352","name":"Stefan Bell","rating":"76","photo":"./data/images/photos/1/198352.png","club":{"name":"FSV Mayence 05","logo":"./data/images/clubs/FSVMayence05.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/StefanBell0.json
// module id = 4005
// module chunks = 0